import { BlockEditorTheme } from '../types';

export const themes: Record<string, BlockEditorTheme> = {
  minimal: {
    name: 'minimal',
    styles: `
      .block-editor {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.6;
        color: #333;
      }
      
      .block-editor [contenteditable] {
        outline: none;
        border: 1px solid transparent;
        border-radius: 4px;
        padding: 0px;
        transition: border-color 0.2s;
      }
      
      .block-editor [contenteditable]:focus {
        border-color: #007cba;
        background-color: #f9f9f9;
      }
      
      .block-editor [contenteditable]:empty:before {
        content: attr(data-placeholder);
        color: #999;
        pointer-events: none;
      }
      
      .block-editor a {
        color: #007cba;
        text-decoration: underline;
        cursor: pointer;
      }
      
      .block-editor a:hover {
        color: #005a87;
        text-decoration: underline;
      }
      
      .block-editor a:visited {
        color: #551a8b;
      }
    `,
    variables: {
      '--primary-color': '#007cba',
      '--border-color': '#ddd',
      '--background-color': '#fff',
      '--text-color': '#333'
    }
  },
  
  modern: {
    name: 'modern',
    styles: `
      .block-editor {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.6;
        color: #1a1a1a;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        padding: 0px;
      }
      
      .block-editor [contenteditable] {
        outline: none;
        border: 2px solid transparent;
        border-radius: 6px;
        padding: 0px;
        transition: all 0.2s ease;
        background: #fff;
      }
      
      .block-editor [contenteditable]:focus {
        border-color: #007cba;
        background: #fff;
        box-shadow: 0 0 0 3px rgba(0, 124, 186, 0.1);
      }
      
      .block-editor [contenteditable]:empty:before {
        content: attr(data-placeholder);
        color: #999;
        pointer-events: none;
      }
      
      .block-editor a {
        color: #007cba;
        text-decoration: underline;
        cursor: pointer;
      }
      
      .block-editor a:hover {
        color: #005a87;
        text-decoration: underline;
      }
      
      .block-editor a:visited {
        color: #551a8b;
      }
      
      .block-editor .article-title {
        font-size: 28px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 24px;
        border-bottom: 2px solid #f0f0f0;
        padding-bottom: 16px;
      }
    `,
    variables: {
      '--primary-color': '#007cba',
      '--border-color': '#e0e0e0',
      '--background-color': '#fff',
      '--text-color': '#1a1a1a',
      '--shadow': '0 2px 8px rgba(0, 0, 0, 0.1)'
    }
  },
  
  wordpress: {
    name: 'wordpress',
    styles: `
      .block-editor {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.6;
        color: #1e1e1e;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
      }
      
      .block-editor [contenteditable] {
        outline: none;
        border: 1px solid transparent;
        border-radius: 2px;
        padding: 8px;
        transition: border-color 0.2s;
        min-height: 1.2em;
      }
      
      .block-editor [contenteditable]:focus {
        border-color: #007cba;
        box-shadow: 0 0 0 1px #007cba;
      }
      
      .block-editor [contenteditable]:empty:before {
        content: attr(data-placeholder);
        color: #999;
        font-style: italic;
      }
      
      .block-editor .article-title {
        font-size: 34px;
        font-weight: 600;
        color: #1e1e1e;
        margin-bottom: 0px;
        border: none;
        padding: 0;
        box-shadow: none;
      }

      /* Placeholder text styling - WordPress style */
      .block-editor [contenteditable]:empty:before {
        content: attr(data-placeholder);
        color: #999;
        pointer-events: none;
      }
      
      .block-editor a {
        color: #007cba;
        text-decoration: underline;
        cursor: pointer;
      }
      
      .block-editor a:hover {
        color: #005a87;
        text-decoration: underline;
      }
      
      .block-editor a:visited {
        color: #551a8b;
      }
      
      .block-editor .wp-block {
        margin: 0em 0;
      }
      
      .block-editor .block-editor-block-list__layout {
        margin-top: 0;
        padding-top: 0;
      }
      
      .block-editor .wp-block-heading {
        font-weight: 600;
        line-height: 1.2;
      }
      
      .block-editor .wp-block-paragraph {
        margin: 0em 0;
      }
    `,
    variables: {
      '--primary-color': '#007cba',
      '--border-color': '#ddd',
      '--background-color': '#fff',
      '--text-color': '#1e1e1e'
    }
  }
};
